import {InstantAppModalPage} from '../InstantAppModal';

export const instantAppModalPageRanking = new Map<InstantAppModalPage | null, number>([
    ['START_APPLICATION', 1],
    ['REVIEW', 2],
    // ['GENERAL_QUESTIONS', 3],
    ['VERIFY_IDENTITY', 4],
    ['APPLICATION', 5],
    ['BOOK_APPOINTMENT', 6],
    ['BANKING_INFO', 6],
    ['BANKING_INFO_LF', 6],
    ['APPROVAL_INFO', 6],
    ['APPROVAL_INFO_LF', 6],
    ['DECISION_APPROVAL', 6],
    ['DECISION_DECLINED', 6],
    ['DECISION_MANUAL_UNDERWRITING', 6],
    ['DECISION_HARD_STOP', 6],
    ['SEND_DOCUSIGN', 6],
    ['ALL_DONE', 7],
]);
